import React, {Component} from 'react';
import Radium from 'radium';
import {Device, darkGray, lightGray} from './shared.js';
import Scroll from 'react-scroll';
const scroll = Scroll.animateScroll;

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.scrollSpeed = 500;
    this.state = { scrolling: false };
    this.naviPointRefs = [];
  }

  componentWillReceiveProps({  activeNavPoint }) {
    if (!this.state.scrolling) {
      this.highlightNavPoint(activeNavPoint);
    }
  }

  componentDidMount() {
    this.highlightNavPoint(this.props.activeNavPoint);
    this.herosection = document.getElementById('herosection');

    document.addEventListener('scroll', () => {
      this.setPosition();
    });
  }

  setPosition() {
    const bottom = this.herosection.getBoundingClientRect().bottom;
    if (bottom <= 0) {
      this.nav.style.position = 'fixed';
      this.nav.style.top = 0;
    } else {
      this.nav.style.position = 'absolute';
      this.nav.style.top = null;
    }
  }

  scrollToArticle() {
    const index = parseInt(arguments[0], 10);
    this.setState({ 'scrolling': true });
    if (Device.isTablet() || Device.isMobile()) {
      this.props.toggleMobileNav();
    }

    const articleReference = document.getElementById(`article${ index }`);
    const y = parseInt(articleReference.offsetTop, 10) + 160;
    scroll.scrollTo(y, { duration: this.scrollSpeed });
    this.highlightNavPoint(index);

    window.setTimeout(() => {
      this.setState({ 'scrolling': false });
    }, this.scrollSpeed);
  }

  highlightNavPoint(index) {
    this.naviPointRefs.forEach((navPoint) => navPoint.style.fontWeight = 400);
    this.naviPointRefs[index].style.fontWeight = 700;
  }

  render() {
    const transitionTiming = this.props.transitionTiming;
    const style = {
      nav: {
        marginLeft: Device.isDesktopLarge() ? '13vw' : null,
        position: 'absolute',
        zIndex: 1,
        paddingBottom: Device.isMobile() ? 30 : null,
        width: Device.isMobile() ? '100%' : null,
        backgroundColor: Device.isMobile() ? lightGray : null,
      },
      header: {
        borderLeftColor: darkGray,
        borderLeftStyle: 'solid',
        borderLeftWidth: 3,
        color: darkGray,
        fontSize: 20,
        marginLeft: Device.isMobile() ? 30 : 40,
        marginTop: Device.isMobile() ? 30 : 40,
        padding: 5,
      },
      list: {
        borderLeft: '3px solid #4A4A4A',
        listStyle: 'none',
        marginBottom: 0,
        marginLeft: Device.isMobile() ? 30 : 40,
        marginTop: (Device.isTablet() || Device.isMobile()) ? 0 : 40,
        padding: 10,
        position: (Device.isMobile() && this.props.open) ? 'relative' : 'absolute',
        transitionDuration: transitionTiming,
        transitionProperty: 'transform',
        transformOrigin: '0 0',
        transform: (Device.isTablet() || Device.isMobile()) && !this.props.open ? 'rotateX(90deg)' : null,
      },
      listElement: {
        color: '#4A4A4A',
        fontSize: 14,
        padding: 5,
        transitionDuration: transitionTiming,
        transitionProperty: 'transform',
        transitionDelay: transitionTiming,
        transitionTiming: 'linear',
        transformOrigin: '0 0',
        transform: (Device.isTablet() || Device.isMobile()) && !this.props.open ? 'rotateY(90deg)' : null,
        whiteSpace: 'nowrap',
        ':hover': {
          cursor: 'pointer',
        }
      },
    };

    const naviPoints = this.props.articles.map((article, index) => {
      return (
        <li 
          onClick={ this.scrollToArticle.bind(this, `${ index }`) } 
          ref={ (navPoint) => this.naviPointRefs[index] = navPoint } 
          key={ article.headline }
          style={ style.listElement }>
          { article.headline }
        </li>
      );
    });

    return (
      <nav 
        ref={(nav) => this.nav = nav}
        style={ style.nav }>
        { 
          (Device.isTablet() || Device.isMobile()) && (
            <header 
              onClick={ this.props.toggleMobileNav } 
              style={ style.header }>
              Menu
            </header>
          )
        }
        <ul style={ style.list }>
          { naviPoints }
        </ul>
      </nav>
    );
  }
}

export default Radium(Navigation);


// WEBPACK FOOTER //
// ./src/modules/navigation.js